import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import { useTownAssets, useTutorial } from '../stores';

import TutorialLaunchButton from './TutorialLaunchButton';

// Title-bar button for a popup's own walkthrough: auto-plays on first open, replays on click.
const PopupTutorialButton = function PopupTutorialButton({ sectionId }) {
  const { tutorial } = useTutorial();
  const { assets } = useTownAssets();
  const { translate } = assets;
  const { playPopupTutorial, endActiveTutorial } = tutorial;
  const autoPlayedRef = useRef(false);

  useEffect(
    () => {
      if (autoPlayedRef.current) return;
      autoPlayedRef.current = true;
      playPopupTutorial(sectionId);
    },
    [sectionId, playPopupTutorial],
  );

  // Closing the popup unmounts the step anchors; tear the tutorial down so busyRef isn't stranded.
  useEffect(
    () => () => { endActiveTutorial(); },
    [endActiveTutorial],
  );

  return (
    <TutorialLaunchButton
      label={translate('tutorialButton', 'tutorial')}
      onClick={() => { playPopupTutorial(sectionId, true); }}
    />
  );
};

PopupTutorialButton.propTypes = {
  sectionId: PropTypes.string.isRequired,
};

export default PopupTutorialButton;
